import actionTypes from '../../actions/actionTypes'
import { Map } from 'immutable';

const INIT_STATE = Map({
    editSelection: false,
    editSelectionSettings: false,
    editSelectionReducedSettings: true,
    editSelectionAutoplay: false,
    editSliderName: false,
    activeTab: 'information',
    activeSelection: '',
    activeDropzones: false,
    requestOverlay: false
})

function setEditSliderName(state, action){
    return state.set('editSliderName', action.payload.value);
}

function setActiveSelection(state, action){
    return state.set('activeSelection', action.payload.activeSelectionID);
}

function setActiveTab(state, action){
    return state.set('activeTab', action.payload.activeTabID);
}

function setActiveDropzonesTrue(state) {
    return state.set('activeDropzones', true);
}

function setActiveDropzonesFalse(state) {
    return state.set('activeDropzones', false);
}

const setEditSelection = (state, action) => {
    return (
        state.set('editSelection', action.payload.selectionId)
            .set('editSelectionSettings', action.payload.selectionType === 'main' || action.payload.selectionType === 'slider' || action.payload.selectionType === 'highlight' || action.payload.selectionType === 'stripe')
            .set('editSelectionReducedSettings', action.payload.selectionType === 'slider' || action.payload.selectionType === 'highlight')
            .set('editSelectionStripeSettings', action.payload.selectionType === 'stripe')
            .set('editSelectionAutoplay', action.payload.selectionType === 'main' || action.payload.selectionType === 'slider')
    );
}

function programReducer(state = INIT_STATE, action) {
    
    if(action === undefined){
        return state;
    }

    switch(action.type){
        case actionTypes.PROGRAM_SET_ACTIVE_TAB:
            return setActiveTab(state, action);
        case actionTypes.PROGRAM_SET_EDIT_SLIDER_NAME:
            return setEditSliderName(state, action);
        case actionTypes.PROGRAM_SET_ACTIVE_SELECTION:
            return setActiveSelection(state, action);
        case actionTypes.UI_PROGRAM_ACTIVE_DROPZONES_SET_TRUE:
            return setActiveDropzonesTrue(state)
        case actionTypes.UI_PROGRAM_ACTIVE_DROPZONES_SET_FALSE:
            return setActiveDropzonesFalse(state)
        case actionTypes.UI_PROGRAM_SET_EDIT_SELECTION:
            return setEditSelection(state, action)
        default:
            return state;
    }
}

export default programReducer;